module.exports = __webpack_public_path__ + "img/tab-modal-delete.eeec35a3.svg";